<template>
  <div class="main_div">
    <section id="container">
      <div style="text-align: center; font-family: 'Noto Sans KR', '맑은 고딕', 'Malgun Gothic', 'dotum';
                  font-weight:bold; font-size: 15px; margin-top:12%; letter-spacing: -1px; color:#555;">
        <p><img src="@/assets/img/etners-web/error_notice_02.png"  width="101" height="73" alt=""/> </p>
        <p style="font-size: 32px;color:#333;line-height: 18px;padding-top:20px;">페이지를 찾을 수 없습니다.</p>
        <p style="padding-top:20px;">입력하신 주소가 잘못 입력되었거나, 변경 또는 삭제되어 페이지를 찾을 수 없습니다. <br>
          입력하신 주소가 정확한지 다시 한번 확인해주세요.</p>
        <p style="margin:auto;margin-top: 30px; width:200px;">
          <button class="large_btn orange" @click="onClickGoMain">메인으로</button>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    onClickGoMain: function () {
      this.$router.push({
        path: '/',
      })
      .catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>
